import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";

export default function DiscordCTA({ discordUrl }) {
  return (
    <div className="glass-red-glow rounded-2xl p-8 md:p-10 relative overflow-hidden">
      <div className="absolute -left-20 -bottom-20 h-64 w-64 rounded-full bg-red-600/25 blur-3xl" />
      <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-red-500/20 blur-3xl" />
      <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-red-300 font-mono mb-2">
            Join the squad
          </div>
          <h3 className="font-display font-black text-3xl md:text-4xl tracking-tight mb-2">
            Discord is where it all happens.
          </h3>
          <p className="text-zinc-300 max-w-md">
            Team sign-ups, live match chat, sponsor drops and giveaways — all in one place.
          </p>
        </div>
        <a
          href={discordUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="discord-cta"
          className="btn-liquid btn-liquid-lg pulse-glow whitespace-nowrap"
        >
          <MessageCircle size={18} /> Join Discord <ArrowRight size={18} />
        </a>
      </div>
    </div>
  );
}
